import LocalStorage from "./LocalStorage";

enum EMessages {
  PIN_MODE_ACCEPTED = "pin_mode_accepted",
}

export default class UIMessages extends LocalStorage<EMessages> {
  private static instance?: UIMessages;

  private constructor() {
    super();
  }

  public static getInstance(): UIMessages {
    if (!this.instance) {
      this.instance = new UIMessages();
    }

    return this.instance;
  }

  public getPinModeAccepted(): string | null {
    // @todo:
    // returns string... consider JSON.parse to boolean
    return this.get(EMessages.PIN_MODE_ACCEPTED);
  }

  public setPinModeAccepted(pinModeAccepted: string): void {
    this.set(EMessages.PIN_MODE_ACCEPTED, pinModeAccepted);
  }

  public clear(): void {
    this.clearItems([EMessages.PIN_MODE_ACCEPTED]);
  }
}
